import { render, staticRenderFns } from "./StatsMemberGender.vue?vue&type=template&id=1f20f876&"
import script from "./StatsMemberGender.vue?vue&type=script&lang=js&"
export * from "./StatsMemberGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports